



















import { Component, Vue } from 'vue-property-decorator';
import SupportedCountry from '@/types/SupportedCountry';
import { BaseGetter } from '@/store/getters';

@Component({
  name: 'breadcrumbs-component',
})
export default class BreadcrumbsComponent extends Vue {
  get country(): SupportedCountry {
    return this.$store.getters[BaseGetter.Country];
  }
}
